
  import { Vue, Component, Prop } from "vue-property-decorator";
  import ProjectsMultiselectOption from "@/entities/ProjectsMultiselectOption";

  @Component
  export default class ProjectMultiselectOption extends Vue {
    @Prop({ type: Object, required: true }) readonly option!: ProjectsMultiselectOption;
    @Prop({ type: Boolean, default: false }) readonly selectedInline!: boolean;

    get optionClasses(): Record<string, boolean> {
      return {
        "flex-col": !this.selectedInline,
        "items-center": this.selectedInline,
      };
    }
  }
